import { render, staticRenderFns } from "./QaQtypeNav.vue?vue&type=template&id=e2ac9b02&scoped=true&"
import script from "@/scripts/QA/QuestionList/components/QaQtypeNav?vue&type=script&lang=js&"
export * from "@/scripts/QA/QuestionList/components/QaQtypeNav?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ac9b02",
  null
  
)

export default component.exports